import React from 'react'
import DataView from 'EurestoComponents/DataForm'
import Constants from 'EurestoFonction/Constants'


export const MotifArchive = () => (
    <DataView module={Constants.module.CONFIGURATION} object={Constants.donnee.profil}/>
)

export default MotifArchive



// WEBPACK FOOTER //
// ./app/App/Module/Configuration/Component/Etablissement/Profil/index.js